import { Card, Space, Spin, Typography } from "antd";
import React, { CSSProperties, useEffect, useRef, useState } from "react";

import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { getCurrentModule } from "~/Utils/StringConstants";
import ConfirmationModal from "../Modal/confirmation-modal";
import styles from "./Layout.module.scss";

interface Props {
  children: React.ReactNode;
  title?: string;
  customTitle?: React.ReactNode;
  actionItems?: React.ReactNode;
  bodyStyle?: CSSProperties;
  loading?: boolean;
  showBack?: boolean;
  airportText?: React.ReactNode;
}

export const ContentWrapper = ({
  children,
  title,
  actionItems,
  customTitle,
  bodyStyle,
  loading = false,
  showBack = false,
  airportText,
}: Props) => {
  const [height, setHeight] = useState(window.innerHeight - 180);
  const [titleHeight, setTitleHeight] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const customTitleRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const [backConfirmationModalVisible, setBackConfirmationModalVisible] = useState(false);

  const currentModule = getCurrentModule();

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 180);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (customTitleRef.current) {
      setTitleHeight(customTitleRef.current.getBoundingClientRect().height + 32);
    } else if (title) {
      setTitleHeight(32 + 32);
    } else {
      setTitleHeight(0);
    }
  }, [title, customTitle, height]);

  return (
    <>
      <Card
        ref={ref}
        className={styles.ContentWrapper}
        bodyStyle={{
          ...bodyStyle,
          height: height - titleHeight + 32,
          overflow: "auto",
          paddingTop: 0,
          paddingBottom: 0,
        }}
        id="contentWrapperContainer"
        style={{
          overflow: "hidden",
          boxSizing: "border-box",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
        title={
          customTitle ? (
            <div ref={customTitleRef}>{customTitle}</div>
          ) : title ? (
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {showBack && (
                  <Icon
                    icon="ic:round-arrow-back"
                    width="28"
                    height="28"
                    className="cursor-pointer"
                    onClick={() => setBackConfirmationModalVisible(true)}
                  />
                )}

                <Typography.Title
                  level={3}
                  style={{ margin: 0 }}
                >
                  {title}
                </Typography.Title>
              </div>

              {airportText && (
                <Typography.Text style={{ fontSize: 14, display: "block", marginTop: 4, color: "#ff0080ff" }}>
                  {airportText}
                </Typography.Text>
              )}
            </div>
          ) : undefined
        }
        extra={actionItems}
      >
        <div
          id="contentWrapperContent"
          style={{ height: "100%", width: "100%" }}
        >
          {children}
        </div>
        {loading && (
          <div className="loadingOverlay">
            <Space size="middle">
              <Spin size="large" />
            </Space>
          </div>
        )}
      </Card>

      <ConfirmationModal
        type="back"
        open={backConfirmationModalVisible}
        onClose={() => setBackConfirmationModalVisible(false)}
        onSubmit={() => navigate(-1)}
      />
    </>
  );
};
